module.exports = __webpack_public_path__ + "static/media/branch-london-mobile.750b5f09.jpg";